import { ControlFilteredOptionLoader } from '../../../shared/utils/control-filtered-option-loader';
import { EquipmentStatus } from '../contract/equipment-status.contract';
import { LanguageService } from '../../../core/services/language.service';
import { computed, signal } from '@angular/core';

export class EquipmentStatusControlFilteredOptionLoader extends ControlFilteredOptionLoader<EquipmentStatus, string> {
  public $searchTerm = signal<string>('');

  public $filteredOptions = computed(() => {
    const term = this.$searchTerm().toLowerCase();
    const options = this.$options();
    const currentLang = this.languageService.getCurrentLocale();

    if (!term) {
      return options;
    }

    return options.filter((status) => {
      const name = status.statusName[currentLang];
      return name?.toLowerCase().includes(term);
    });
  });

  constructor(private readonly languageService: LanguageService) {
    super();
  }

  searchChange(term: string): void {
    this.load(term);
    this.$searchTerm.set(term);
  }
}
